videojs.addLanguage('hi', {
  "Audio Player": "ऑडियो प्लेयर",
  "Video Player": "वीडियो प्लेयर",
  "Play": "चलाएँ",
  "Pause": "रोके",
  "Replay": "फिर से चलाएँ",
  "Current Time": "वर्तमान समय",
  "Duration": "अवधि",
  "Remaining Time": "शेष समय",
  "Stream Type": "स्ट्रीम प्रकार",
  "LIVE": "लाइव",
  "Seek to live, currently behind live": "छोड़कर लाइव प्रसारण पर आगे बढ़ें, अभी लाइव प्रसारण से पीछे हैं",
  "Seek to live, currently playing live": "छोड़कर लाइव प्रसारण पर आगे बढ़ें, अभी लाइव चल रहा है",
  "Loaded": "लोड हुआ",
  "Progress": "प्रगति",
  "Progress Bar": "प्रोगेस बार",
  "progress bar timing: currentTime={1} duration={2}": "{2} में से {1}",
  "Fullscreen": "फ़ुल स्क्रीन",
  "Non-Fullscreen": "फ़ुल स्क्रीन से बाहर निकलें",
  "Mute": "म्यूट करें",
  "Unmute": "अनम्यूट करें",
  "Playback Rate": "चलाने की दर",
  "Subtitles": "उपशीर्षक",
  "subtitles off": "उपशीर्षक बंद",
  "Captions": "कैप्शन",
  "captions off": "कैप्शन बंद",
  "Chapters": "अध्याय",
  "Descriptions": "विवरण",
  "descriptions off": "विवरण बंद",
  "Audio Track": "ऑडियो ट्रैक",
  "Volume Level": "वॉल्यूम स्तर",
  "You aborted the media playback": "आपने मीडिया प्लेबैक को रोक दिया",
  "A network error caused the media download to fail part-way.": "एक नेटवर्क त्रुटि के कारण मीडिया डाउनलोड आंशिक रूप से विफल हो गया।",
  "The media could not be loaded, either because the server or network failed or because the format is not supported.": "मीडिया लोड नहीं किया जा सका, या तो सर्वर या नेटवर्क विफल होने के कारण या प्रारूप समर्थित नहीं होने के कारण।",
  "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "मीडिया प्लेबैक निरस्त कर दिया गया, कारण: दूषण की समस्या या मीडिया ने उन सुविधाओं का उपयोग किया था जिनका आपके ब्राउज़र ने समर्थन नहीं किया।",
  "No compatible source was found for this media.": "इस मीडिया के लिए कोई अनुकूल स्रोत नहीं मिला।.",
  "The media is encrypted and we do not have the keys to decrypt it.": "मीडिया एन्क्रिप्टेड है और हमारे पास इसे डिक्रिप्ट करने की चाबी नहीं है।",
  "Play Video": "वीडियो चलाएं",
  "Close": "बंद करे",
  "Close Modal Dialog": "मोडल डायलॉग बंद करें",
  "Modal Window": "मोडल विंडो",
  "This is a modal window": "यह एक मोडल विंडो है",
  "This modal can be closed by pressing the Escape key or activating the close button.": "इस मोडल को एस्केप कुंजी दबाकर या बंद करें बटन को सक्रिय करके बंद किया जा सकता है।",
  ", opens captions settings dialog": ", कैप्शन सेटिंग डायलॉग खोलता है",
  ", opens subtitles settings dialog": ", उपशीर्षक सेटिंग्स संवाद खोलता है",
  ", opens descriptions settings dialog": ", विवरण सेटिंग संवाद खोलता है",
  ", selected": ", चुना गया",
  "captions settings": "कैप्शन सेटिंग",
  "subtitles settings": "उपशीर्षक सेटिंग",
  "descriptions settings": "विवरण सेटिंग",
  "Text": "टेक्स्ट",
  "White": "सफेद",
  "Black": "काला",
  "Red": "लाल",
  "Green": "हरा",
  "Blue": "नीला",
  "Yellow": "पीला",
  "Magenta": "मैजेंटा",
  "Cyan": "सियान",
  "Background": "बैकग्राउंड",
  "Window": "विंडो",
  "Transparent": "पारदर्शी",
  "Semi-Transparent": "अर्द्ध पारदर्शी",
  "Opaque": "अपारदर्शी",
  "Font Size": "फ़ॉन्ट आकार",
  "Text Edge Style": "टेक्स्ट एज स्टाइल",
  "None": "कोई नहीं",
  "Raised": "उठा हुआ",
  "Depressed": "उदास",
  "Uniform": "वर्दी",
  "Dropshadow": "परछाई",
  "Font Family": "फॉण्ट परिवार",
  "Proportional Sans-Serif": "प्रोपोरशनल साँस-सेरिफ",
  "Monospace Sans-Serif": "मोनोस्पास साँस-सेरिफ",
  "Proportional Serif": "प्रोपोरशनल सेरिफ",
  "Monospace Serif": "मोनोस्पास सेरिफ",
  "Casual": "आकस्मिक",
  "Script": "स्क्रिप्ट",
  "Small Caps": "छोटे अक्षर",
  "Reset": "रीसेट करें",
  "restore all settings to the default values": "सभी सेटिंग्स को डिफ़ॉल्ट मानों पर पुनर्स्थापित करें",
  "Done": "पूर्ण",
  "Caption Settings Dialog": "कैप्शन सेटिंग्स डायलॉग",
  "Beginning of dialog window. Escape will cancel and close the window.": "डायलॉग विंडो की शुरुआत। एस्केप विंडो को रद्द और बंद कर देगा।",
  "End of dialog window.": "संवाद विंडो का अंत।",
  "{1} is loading.": "{1} लोड हो रहा है।",
  "Exit Picture-in-Picture": "पिक्चर-इन-पिक्चर से बाहर निकलें",
  "Picture-in-Picture": "पिक्चर-इन-पिक्चर"
});